module.exports = {
          srcSet: __webpack_public_path__ + "3cafc165ebccfc848fc7b76271300d50-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "3cafc165ebccfc848fc7b76271300d50-60.png",width: 60,height: 60}],
          src: __webpack_public_path__ + "3cafc165ebccfc848fc7b76271300d50-60.png",
          toString:function(){return __webpack_public_path__ + "3cafc165ebccfc848fc7b76271300d50-60.png"},
          
          width: 60,
          height: 60
        }